import { useSelector } from "react-redux";
import { gettoken, getvoucher } from "../../../../Localstorage/Store";
import Accountprice from "../../../../utils/Accountprice";
import { BsInfoCircle } from 'react-icons/bs';
import axios from "axios";
import { useRef, useState } from "react";
const CouponSection = ({ couponInfo, cartInfo, setshowbtn }) => {
    console.log("check coupon info is here",couponInfo);
    console.log("check coupon info is here cart info",cartInfo);
  const tokenvalue = gettoken();
  const localvouhcer = getvoucher();
  const [voucherdesc, setvoucherdesc] = useState([]);
  const {bgColor, textColor } = useSelector((state) => state.theam);
  const [vouchervalue, setvouchervalue] = useState("");
  const [vouchererror, setvouchererror] = useState("");
  const closeref = useRef(null);
  const openalert = useRef(null);


  const alertb = () => {
    openalert.current.click();
    setTimeout(() => {
      setvouchererror("");
      closeref.current.click();
    }, 3000);
  };

  const applyvoucher = async (vouchercode) => {
    setshowbtn(false)
    if (!vouchercode || vouchercode === "") return;
    try {
      const formdata = new FormData();
      formdata.append("vouchercode", vouchercode);
      const config = {headers: {Authorization: `Bearer ${tokenvalue.access}`}};
      let url = `${process.env.REACT_APP_API_URL}cartapi/assign-voucher/`;
      const response = await axios.post(url, formdata, config);
      if (response.data == "voucher is not clubable") {
        setvouchererror("voucher is not clubable");
        alertb()
      }
      if (!response.data.code) {
        setvouchererror(response.data);
      } else {
        setvouchererror("");
      }
      setvouchervalue("");
      cartInfo.cartRefetch();
    } catch (error) {
      console.log("sdfghdddddddddddd", error)
      if (error.response.data.non_field_errors) {
        setvouchererror(error.response.data.non_field_errors[0]);
        alertb()
      }
      if (error.response.data.msg) {
        setvouchererror(error.response.data.msg);
        alertb()
        return
      }
      if (error.response.data) {
        setvouchererror(error.response.data);
        alertb()
      }
    }
  };

  const removevoucher = async (codename) => {
    try {
      const formdata = new FormData();
      formdata.append("vouchercode", codename);
      const config = { headers: { Authorization: `Bearer ${tokenvalue.access}` } };
      let url = `${process.env.REACT_APP_API_URL}cartapi/remove-voucher/`;
      const response = await axios.post(url, formdata, config);
      cartInfo.cartRefetch();
    } catch (error) {
      console.log("error", error.response.data);
    }
  };

  const funvoucherdesc = (item) => {
    const validJsonString = item.replace(/'/g, '"');
    setvoucherdesc(JSON.parse(validJsonString))
  }

  return (
   <div
                        style={{
                          backgroundColor: "white",
                          padding: "0px 6px",
                          marginBottom: "8px",
                        }}
                      >
                        <table className="table bg-white mt-3">
                          <tbody>
                              <tr className="" style={{ borderColor: "#333" }}>
                                <td
                                  style={{
                                    fontWeight: "700",
                                    fontSize: "18px",
                                    display: "flex",
                                    gap: "19px",
                                    alignItems: "center",
                                    flexWrap: "wrap",
                                  }}
                                >
                                  <span>Redeem Coupon</span>
                               
                                </td>
                              </tr>
                          </tbody>
                        </table>

                        <div
                          className="newscrollerbar"
                          style={{ width: "100%" }}
                        >
                          <table
                            className="table-responsive bg-white mt-3"
                            style={{ width: "100%" }}
                          >
                            <tbody>
                                <>
                                  <tr>
                                    <th
                                      style={{
                                        textAlign: "center",
                                        fontSize: "12px",
                                        width: "8%",
                                      }}
                                    >
                                      S.NO
                                    </th>
                                    <th
                                      style={{
                                        textWrap: "nowrap",
                                        fontSize: "12px",
                                        width: "18%",
                                      }}
                                    >
                                      Coupon Code
                                    </th>
                                    <th
                                      style={{
                                        textWrap: "nowrap",
                                        fontSize: "12px",
                                      }}
                                      className="px-lg-0 px-2"
                                    >
                                      Description
                                    </th>
                                  
                                    <th
                                      style={{
                                        textWrap: "nowrap",
                                        fontSize: "12px",
                                        width: "7%",
                                      }}
                                      className="px-lg-0 px-2"
                                    >
                                      Value
                                    </th>
                                    <th></th>
                                  </tr>

                                  {couponInfo.couponlist.map((item, index) => (
                                        <tr>
                                          <td>
                                            <span
                                              style={{
                                                display: "flex",
                                                width: "100%",
                                                justifyContent: "center",
                                              }}
                                            >
                                              {1}
                                            </span>
                                          </td>
                                          <td>
                                            <div>
                                              <div
                                                className="firstrow  justify-content-between mt-1 py-1 align-items-center"
                                                style={{display:"flex"}}
                                              >
                                                <div
                                                  className="firstcontianer d-flex align-items-center"
                                                  style={{ gap: 4 }}
                                                >
                                                  <div className="containerimg">
                                                    <img
                                                      src="/images/carticon.png"
                                                      style={{ width: "15px" }}
                                                      alt={404}
                                                    />
                                                  </div>
                                                  <div
                                                    style={{
                                                      display: "flex",
                                                      justifyContent:
                                                        "space-between",
                                                      gap: "4px",
                                                      alignItems: "baseline",
                                                      minWidth: "192px",
                                                    }}
                                                  >
                                                    <p
                                                      className="m-0"
                                                      style={{
                                                        fontWeight: 400,
                                                        fontSize: "12px",
                                                      }}
                                                    >
                                                      {item.code} 
                                                     
                                                    </p>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </td>
                                          <td style={{ fontSize: "12px" }}>
                                            {item.description.replace(/[\[\],\']/g,"")}
                                          </td>

                                          <td style={{ fontSize: "12px" }}>
                                          
                                             {Accountprice(item.offer)}

                                          </td>
                                          <td>
                                            <div></div>
                                          </td>
                                        </tr>
                                      ))}

                                 
                                </>
                              
                            </tbody>
                          </table>
                        </div>
                      </div>
  )
}

export default CouponSection